import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import CommonModal from 'src/components/CommonModal';
import { MEASUREMENT } from 'src/constants/common';

import { IMismatchModal } from './quoteDetailModal.interface';

const WeightMismatchModal: FC<IMismatchModal> = ({ handleActionClose, handleMismatch, data }) => {
    const { t } = useTranslation();

    return (
        <CommonModal
            title={<h6 className="text-textSecondary text-lg font-semibold">{t('QuotingHub.QuotingDashboard.Total_Weight_Mismatch')}</h6>}
            modalTitleDesc={
                <>
                    <p className="text-grayLight600 text-sm font-normal">{t('QuotingHub.QuotingDashboard.Weight_mismatch')}</p>
                    <p className="text-grayLight600 text-sm font-normal">
                        {t('QuotingHub.QuotingDashboard.Review_Dimensions_Keep')}{' '}
                        <span className="font-semibold text-primary">{data ? `${data?.totalWeight} ${data?.weightMeasurement === MEASUREMENT.WEIGHT1.value ? 'lbs' : 'kgs'}` : ''}</span>?
                    </p>
                </>
            }
            modalHeaderClass="border-b-0 !px-6 !pt-6 !pb-5 !bg-transparent"
            modalHeaderTextClass="!flex-col"
            modalFooterClass="border-t-0 !bg-transparent"
            closeBtnClass="-mt-2 -mr-2"
            handleClose={handleActionClose(false)}
            size={'max-w-[420px]'}
            primaryBtnText={`Keep as ${data?.totalWeight} ${data?.weightMeasurement === MEASUREMENT.WEIGHT1.value ? 'lbs' : 'kgs'}`}
            secondaryBtnText={t('QuotingHub.QuotingDashboard.Review_Dimensions')}
            secondaryBtnOnClick={handleActionClose(true)}
            primaryBtnOnClick={handleMismatch}
        >
            <></>
        </CommonModal>
    );
};

export default WeightMismatchModal;
